/*
 * catches links that haven't been converted to links by the editor
 * and converts them to links
 * @param {string} html - the HTML content to process
 * @returns {string} - the processed HTML content with links converted
 */
export function updateLinksOnRender(html: string): string {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

  const urlRegex = /(\bhttps?:\/\/[^\s<]+[^\s<.,:;"')\]\s])/g;

  let node: Node | null;
  while ((node = walker.nextNode())) {
    const parent = node.parentElement;
    if (parent?.tagName === "A") continue;

    const text = node.textContent;
    if (!text) continue;

    const newHTML = text.replace(urlRegex, url => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    if (newHTML !== text) {
      const span = document.createElement("span");
      span.innerHTML = newHTML;
      parent?.replaceChild(span, node);
    }
  }

  return doc.body.innerHTML;
}
